/**
 * Monday's "DCF EMAIL CREATED = Stuck", shown in the UMED board's DCF account cell (Isaiah Cotto, ruling #6, 2026-10-07).
 *
 * A MONDAY MARKER ONLY: it is shown, never applied. eMerge is canonical and Monday is provenance, so the word sets no
 * DCF account state, no stage, tab or count, and offers no action. It is the board's own word (UMEDs board 8146038673,
 * column color_mkvt65jr), carried by the sync into umed_requests.monday_dcf_email_created and read for the same board
 * row "Monday says" reads (mondayDifference.js). Only Stuck is shown: Working on it and Done say nothing eMerge's own
 * DCF account record does not already say better.
 *
 * Styled as the existing "Monday says" marker (.um-mondaydiff .um-tag.attn: amber, dashed, the M badge). The column
 * has no entry in theme/mondayPalette.ts, so no Monday colour is used and none is guessed.
 */
import React from 'react';
import { normalizeMondayWord } from '../../theme/mondayPalette';

export const MONDAY_DCF_EMAIL_STUCK = 'Monday: DCF email Stuck';

export const MONDAY_DCF_EMAIL_EXPLAIN = 'Monday\'s DCF EMAIL CREATED column says Stuck for this UMED. It is shown for reference only: '
  + 'eMerge does not take it from Monday, and nothing here changes because of it.';

/** True when Monday's DCF EMAIL CREATED word is Stuck, compared as the board's words are (trim, case). */
export function mondayDcfEmailStuck(word: string | null | undefined): boolean {
  return normalizeMondayWord(word) === 'STUCK';
}

/** The row fields this cell reads: the row's id (so any board row fits) and the board's raw word. */
export interface MondayDcfEmailRow {
  id: string;
  monday_dcf_email_created?: string | null;
}

export function MondayDcfEmailMarker({ row }: { row: MondayDcfEmailRow }) {
  if (!mondayDcfEmailStuck(row.monday_dcf_email_created)) return null;
  return (
    <span className="um-mondaydiff compact" data-testid="monday-dcf-email-stuck">
      <span className="um-tag attn" title={MONDAY_DCF_EMAIL_EXPLAIN}>
        {MONDAY_DCF_EMAIL_STUCK}
        <span className="um-sr-only">. {MONDAY_DCF_EMAIL_EXPLAIN}</span>
      </span>
    </span>
  );
}

export default MondayDcfEmailMarker;
